export default "__VITE_ASSET__Bkto7uWr__"